const HEX_COLORS = [
    { label: 'Vermelho Claro', value: '#FB958E' },
    { label: 'Laranja Claro', value: '#FBCF8E' },
    { label: 'Amarelo', value: '#FFD52F' },
    { label: 'Verde Escuro', value: '#2E7D32' },
    { label: 'Ciano Claro', value: '#73E5E2' },
    { label: 'Azul Claro', value: '#8E97FB' },
    { label: 'Azul Escuro', value: '#1F86DA' },
    { label: 'Vermelho Intenso', value: '#DA1F23' },
    { label: 'Roxo Intenso', value: '#DA1FC1' }
]
export default HEX_COLORS